angular = require('angular')
_ = require('lodash')

tinymce = require('tinymce/tinymce')
require('tinymce/themes/modern')

require('tinymce/plugins/table')
require('tinymce/plugins/link')
require('tinymce/plugins/lists')
require('tinymce/plugins/tabfocus')
require('tinymce/plugins/autolink')
require('tinymce/plugins/advlist')
require('tinymce/plugins/autoresize')
require('tinymce/plugins/paste')
require('./plugins/annotate/plugin')
require('./plugins/mention/plugin')

app = angular.module('workflow.app')

app.directive 'tinymce', ($timeout, Api, $stateParams) ->
  scope:
    isInlineEditor: '='
    starredDocs:    '='
    user:           '='
    scrollToComment: '=?'
    onBlur: '&?'
    showGptSummary: '=?'
  require: 'ngModel'
  template: """
    <div ng-form="forms.form">
      <div class="tiny-mce-toolbar-container" id="tinymce-toolbar-container-{{ uniqueId }}"></div>
      <div ng-if="tinymceOptions" ui-tinymce="tinymceOptions" ng-model="model.inner" name="innerNgModelController" class="form-control"></div>
    </div>
  """
  link: (scope, element, attrs, outerNgModelController) ->
    scope.model =
      inner: outerNgModelController.$modelValue

    scope.isSavingAfterBlurNeeded = false
    scope.possiblyMentionAdded = false
    scope.preventOuterDataAfterBlur = false

    scope.saveAfterBlur = () ->
      if scope.isSavingAfterBlurNeeded
        scope.isSavingAfterBlurNeeded = false
        scope.possiblyMentionAdded = false
        scope.preventOuterDataAfterBlur = true
        $timeout(
          () ->
            scope.onBlur?()
        )

    # The parser is called when the inner view value changes,
    # i.e. when the user has typed text
    # The ngModelController is not initially on the scope,
    # so we watch for the first tiny it is truthy
    unreg = scope.$watch 'forms.form.innerNgModelController', (innerNgModelController) ->
      if innerNgModelController
        unreg()
        innerNgModelController.$parsers.push (innerViewValue) ->
          outerNgModelController.$setViewValue(innerViewValue)
          scope.saveAfterBlur()
          # Must return something that isn't undefined otherwise Angular 1.3+ treats the
          # outer form as invalid
          innerViewValue

    # The formatter is called when the outer model value changes,
    # i.e. on initialisation
    outerNgModelController.$formatters.push (outerModelValue) ->
      if !scope.preventOuterDataAfterBlur
        scope.model.inner = outerModelValue
      else
        scope.preventOuterDataAfterBlur = false

    # Prevent dragging of element if this in in a sortable
    # This is consistent with standard form elements
    element.on 'mousedown', (e) ->
      e.stopPropagation()

    # So TinyMCE can place its toolbar in a div we can find and control
    scope.uniqueId = scope.$id

    toolbarExtras = ''

    if scope.user?
      if 'workflow.can_add_summary_comments' in scope.user.permissions
        toolbarExtras += '| annotate delete-annotation '
      if scope.showGptSummary
        if scope.user.client_platform_configuration?.gpt_executive_summary_available && 'workflow.can_generate_gpt_summary' in scope.user.permissions
          toolbarExtras += ' | executive-summary | '
      if 'workflow.use_watchlist_summary' in scope.user.permissions
        toolbarExtras += '| watchlistresult '

    scope.$watch 'scrollToComment', (commentOrderId) ->
      if scope.editor
        editorBody = scope.editor.getBody()
        target = $(editorBody).find('span[data-annotation-value]')[commentOrderId]
        scrollTop = target.offsetTop - editorBody.offsetTop
        editorBody.scrollTop = scrollTop

    scope.tinymceOptions =
      plugins: 'table link lists tabfocus autolink advlist autoresize mention annotate paste'
      autoresize_max_height: 500
      autoresize_bottom_margin: 0
      branding: false
      menubar: false
      browser_spellcheck: true
      toolbar: 'undo redo | styleselect | bold italic | bullist numlist outdent indent | link table ' + (toolbarExtras || '')
      statusbar: false
      content_style: "*{font-family: Roboto, sans-serif}p," +
        "li{font-size: 14px;line-height:1.42857143}div.watchlist-result" +
        "{background-color: #fdf4dd;background-color: rgba(253, 244, 221, 0.5)}" +
        "span.annotation {background-color:#ff0; background-color: rgba(255, 255, 0, 0.8) }"
        # Also update watchlist-result style in inline-editor.less if changed
      inline: !scope.isInlineEditor  # Yes, our "inline" does not use TinyMCE "inline"
      fixed_toolbar_container: '#tinymce-toolbar-container-' + scope.uniqueId
      mentions:
        delimiter: '#'
        items: 100
        insert: (item) ->
          if item.is_doc
            if item.url?
              return "&nbsp;<a href='#{item.url}' target='_blank' " +
              "class='norman-url'><span class='doc-reference' " +
              "style='background:#E7E7E7;padding:2px'>##{item.id}</span></a>&nbsp;"
            return "&nbsp;<span class='doc-reference' style='background:#E7E7E7;padding:2px'>##{item.id}</span>&nbsp;"
          return ""
        matcher: (items) ->
          return items
        render: (item) ->
          scope.possiblyMentionAdded = true
          if item.is_doc
            if item.snippet?
              return "<li style='margin-left: 15px;'><a href='javascript:;'><strong>##{item.name}</strong><br>#{item.snippet}</a></li>"
            return "<li style='margin-left: 15px;'><a href='javascript:;'><strong>##{item.name}</strong></a></li>"
          if item.first?
            return "<li class='dropdown-header'>#{item.name}</li>"
          return "<li class='dropdown-header' style='border-top-width: thin; border-top-style: double; border-top-color: #e5e5e5;'>#{item.name}</li>"
        sorter: (items) ->
          getWorkflowSteps = (items) ->
            results = []
            results.push {name: doc.workflow_step_name, workflow_step: doc.workflow_step} for doc in items
            results = _.unique results, (step) ->
              step.workflow_step
            return results

          extendItemsWithWorkflowStepsAndSort = (items, workflowsSteps) ->
            items.unshift {name: step.name, workflow_step: step.workflow_step, is_doc: false} for step in workflows_steps
            items.sort (obj1, obj2) ->
              if obj1.workflow_step < obj2.workflow_step     then -1 else \
              if obj1.workflow_step > obj2.workflow_step     then  1 else \
              if obj1.is_doc == false && obj2.is_doc == true then -1 else \
              if obj1.is_doc == true && obj2.is_doc == false then  1 else \
              if obj1.id < obj2.id                           then -1 else \
              if obj1.id > obj2.id                           then  1 else \
                                                                   0
            return items

          workflows_steps = getWorkflowSteps(items)
          items = extendItemsWithWorkflowStepsAndSort(items, workflows_steps)
          items[0].first = true if items.length
          return items
        source: (query, process) ->
          getTitle = (doc) ->
            return  if d.result?.title? then d.result.title else d.title

          getDoc = (doc) ->
            return {
              id: doc.id
              name: doc.id + ' ' + getTitle(doc)
              snippet: doc.snippet
              workflow_step: doc.workflow_step
              workflow_step_name: doc.workflow_step_name
              url: doc.url
              is_doc: true
            }

          if not scope.starredDocs or scope.starredDocs.length is 0 or not query
            docs = (getDoc(d) for k, d of scope.starredDocs)
            return docs

          matchQuery = (doc, query) ->
            return (
              doc.title.toLowerCase().indexOf(query.toLowerCase()) > -1 or
              doc.id.toString().indexOf(query) > -1 or
              doc.workflow_step_name.toLowerCase().indexOf(query.toLowerCase()) > -1
            )

          filtered = (getDoc(d) for k, d of scope.starredDocs when matchQuery(d, query))
          process(filtered)
      setup: (editor) ->
        scope.editor = editor
        editor.addButton('executive-summary',
          icon: 'thunderbolt-icon'
          tooltip: 'Insert auto-generated executive summary'
          onclick: () ->
            new Api.ExecutiveSummary({id: $stateParams.projectId}).$get().then((response) ->
              editor.insertContent("<div class=\"watchlist-result\">")
              for executive_summary in response.executive_summaries
                editor.insertContent(
                  "<h3>#{executive_summary.target_entity.join(', ')}</h3><p>#{executive_summary.executive_summary}</p>"
                )
              editor.insertContent("</div>")
            )
        )
        editor.addButton('watchlistresult',
          text: 'Watchlist Result'
          icon: false
          onclick: () ->
            editor.insertContent('<div class="watchlist-result"><h3>International Watchlist Screening Result</h3><p>Insert here.</p></div>')
        )
        editor.on 'init', () ->
          editorBody = editor.getBody()
          $(editorBody).on 'click', 'a[href]', (e) ->
            url = $(e.currentTarget).attr('href')
            window.open(url)

          $(editorBody).on 'blur', () ->
            scope.isSavingAfterBlurNeeded = true
            if !scope.possiblyMentionAdded
              scope.saveAfterBlur()

        if scope.isInlineEditor
          $timeout () ->
            editor.focus()
        else
          toolbarShown = false
          editor.on 'activate', ->
            toolbarContainer = element.find('.tiny-mce-toolbar-container')
            if not toolbarShown
              toolbarContainer.hide()
              # Must slide down thec container after the toolbar is shown,
              # but unable to find a TinyMCE event that fires after that
              $timeout (() -> toolbarContainer.slideDown(250)), 0, false
            toolbarShown = true
